import { i18n } from '@lingui/core';
import { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import '@warp-ds/icons/elements/search-24';
import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import {
    SelectAction,
    type ActionFunction,
    type ResultsProps,
} from './ResultTypes';

export const FALLBACK_RESULT = {
    resultType: 'SEARCH_FINN',
} as Result;

export const globalSearchResultsAction: ActionFunction = ({
    metaData,
    result,
    value,
}) => {
    if (result === FALLBACK_RESULT) {
        return SelectAction.KEEP_OPEN;
    }
    trackResultClick(result, metaData.tracking);
    const replacedUrl = result.url.replace('REPLACEME', value);
    window.location.href = replacedUrl;
    return SelectAction.CLOSE;
};

export function GlobalSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    return (
        <ResultGroup
            className="border-t pt-24"
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            {resultGroup.results.map((result) => (
                <ResultOption
                    linkClass="flex items-center space-x-8"
                    key={`${result.resultType}-${result.order}-${resultId}`}
                    result={result}
                >
                    {/* @ts-expect-error Property 'w-icon-search-24' does not exist on type 'JSX.IntrinsicElements'.ts(2339) */}
                    <w-icon-search-24 class="flex" />
                    <span className="s-text-link">
                        {i18n.t({
                            id: 'results.globalsearch.link',
                            message: 'Find more results for',
                        })}
                        {' ' /* intentional whitespace */}
                        <b className="query">{result.originalQuery}</b>
                    </span>
                </ResultOption>
            ))}
        </ResultGroup>
    );
}
